"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stimulus_1 = require("@hotwired/stimulus");
class default_1 extends stimulus_1.Controller {
    get el() {
        return this.element;
    }
    connect() {
        const locationInput = this.el.querySelector("[name=locationId]");
        locationInput === null || locationInput === void 0 ? void 0 : locationInput.addEventListener("change", (event) => {
            const target = event.target;
            this.el.submit();
        });
        // Handle date input changes to show/hide time filter
        const dateInput = this.el.querySelector("[name=departingDate]");
        dateInput === null || dateInput === void 0 ? void 0 : dateInput.addEventListener("change", (event) => {
            this.toggleTimeFilter();
        });
        // Initial state
        this.toggleTimeFilter();
    }
    showFilterDialog() {
        this._log("showFilterDialog:start");
        this.filterDialogController = this.application.getControllerForElementAndIdentifier(this.filterDialogTarget, "dialog");
        this.filterDialogPromise = this.filterDialogController.show();
        this._log("showFilterDialog:start");
    }
    hideFilterDialog(event) {
        var _a;
        this._log("showFilterDialog:start");
        this.filterDialogPromise = undefined;
        (_a = this.filterDialogController) === null || _a === void 0 ? void 0 : _a.close();
        this._log("showFilterDialog:end");
    }
    clearFilters(event) {
        const boatNameInput = this.element.querySelector("[name='boatName']");
        if (boatNameInput) {
            boatNameInput.value = "";
        }
        const estimatedGuestsInput = this.element.querySelector("[name='estimatedGuests']");
        if (estimatedGuestsInput) {
            estimatedGuestsInput.value = "";
        }
        const departingDateInput = this.element.querySelector("[name='departingDate']");
        if (departingDateInput) {
            departingDateInput.value = "";
        }
        // Reset time selection to flexible
        const timeInputs = this.element.querySelectorAll("[name='departingTime']");
        timeInputs.forEach((el) => {
            el.checked = el.value === "flexible";
        });
        const minPriceSelect = this.element.querySelector("[name='minPrice']");
        if (minPriceSelect) {
            minPriceSelect.value = "";
        }
        const maxPriceSelect = this.element.querySelector("[name='maxPrice']");
        if (maxPriceSelect) {
            maxPriceSelect.value = "";
        }
        const durationInputs = this.element.querySelectorAll("[name='duration']");
        durationInputs.forEach((el) => (el.checked = false));
        const sortInputs = this.element.querySelectorAll("[name='sort']");
        sortInputs.forEach((el) => (el.checked = false));
        // Hide time filter when clearing
        this.toggleTimeFilter();
    }
    toggleTimeFilter() {
        const dateInput = this.el.querySelector("[name='departingDate']");
        const timeFieldset = this.el.querySelector("#time-filter");
        if (dateInput && timeFieldset) {
            const hasDate = dateInput.value.trim() !== "";
            timeFieldset.style.display = hasDate ? "block" : "none";
        }
    }
    render() { }
    _log(text) {
        console.log(this.identifier + ":" + text);
    }
}
exports.default = default_1;
default_1.targets = ["locationDialog", "filterDialog"];
